import React, { useEffect } from 'react';

import { Box, Grid, Typography } from '@explorer/core';
import { useUser } from '@explorer/stores';
import CloudOffOutlinedIcon from '@mui/icons-material/CloudOffOutlined';
import { Theme } from '@mui/material';
import { createStyles, makeStyles } from '@mui/styles';

import { useDatadogRum } from '@crucible-risk/react-monitoring';

const useStyles = ({}: Partial<ErrorStateProps>) =>
  makeStyles(
    ({}: Theme) =>
      createStyles({
        error: {
          color: 'indianred',
        },
      }),
    { index: 1 },
  )();

/**
 * ErrorState description.
 */
export const ErrorState = ({
  height = 360,
  errorCode,
  errorMsg = 'Something went wrong',
  hideContact = false,
}: ErrorStateProps) => {
  const classes = useStyles({});

  const { addError } = useDatadogRum();
  const { user } = useUser();

  useEffect(() => {
    addError(new Error('Error State Shown'), {
      errorMessage: errorMsg,
      permissions: user?.permissions,
    });
  }, [addError, errorMsg, user?.permissions]);

  return (
    <Box height={height}>
      <Grid
        container
        direction="column"
        alignItems="center"
        justifyContent="center"
        className={classes.error}
        height={height}
      >
        <Grid item>
          <CloudOffOutlinedIcon style={{ fontSize: '5rem' }} />
        </Grid>
        {errorCode && (
          <Grid item>
            <Typography variant="h1" fontSize="5rem">
              {errorCode}
            </Typography>
          </Grid>
        )}
        <Grid item>
          <Typography variant="h3">{errorMsg}</Typography>
        </Grid>
        <Grid item>
          {!hideContact && (
            <Typography variant="bodyS" py={1}>
              Please contact the Customer Security Team
            </Typography>
          )}
        </Grid>
      </Grid>
    </Box>
  );
};

export interface ErrorStateProps {
  height?: number;
  errorCode?: number | string;
  errorMsg?: string;
  hideContact?: boolean;
}
